import fetch from 'features/common/fetch';
import { getUser } from 'features/views/user/selectors';
import { getContextUser } from 'features/views/userContext/selectors';

import { setSemaphoreData } from './slice';

export const fetchSemaphoreDashboard = () => (dispatch, getState) => {
	const userLogin = getUser(getState());
	const contextUser = getContextUser(getState());
	const userName = contextUser ? contextUser.login : userLogin;

	dispatch(
		fetch.actions.get(fetch.constants.urls.semaphoreDashboard, {
			queryParams: {
				userName,
			},
			additionalHeaders: contextUser ? { 'X-Context-User': contextUser.login } : {},
			onSuccess: [
				({ body }) =>
					() => {
						dispatch(setSemaphoreData(body));
					},
			],
		}),
	);
};
